import React from "react";

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  className,
  isLoading = false,
  disabled = false
}) => {
  return (
    <label
      className={`inline-flex items-center ${
        isLoading ? "cursor-progress" : disabled ? "cursor-not-allowed" : "cursor-pointer"
      } ${className}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="sr-only peer"
        disabled={isLoading || disabled}
      />
      <div
        className={`relative w-11 h-6 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 ${
          isLoading ? "bg-gray-300" : "bg-gray-400"
        }`}
      ></div>
    </label>
  );
};

export default Toggle;
